'use client';

export const classes = {
  app: 'h-screen w-screen absolute top-0 left-0 overflow-hidden bg-no-repeat bg-cover bg-site-background',
};
